(function(){
  var OPTIONS = {
    'Junk removal': ['One large item','Quarter load','Half load','Three-quarter load','Full load','Not sure'],
    'Transport': ['Curbside pickup','Delivery','Hard-access transport','Not sure yet'],
    'Moving': ['One item move','Two-person crew','Large & specialty move','Not sure yet'],
    'Handyman': ['Furniture assembly','TV mounting & wall hanging','Door & window repairs','Drywall patch & repair','Painting & touch-ups','Light fixture & fan swaps','Faucet & fixture swaps','Caulking & sealing','Fence & gate repairs','Shelving & garage storage','Small repairs & odd jobs','Other / custom project'],
    'Landscaping': ['Lawn & yard cleanup','Mowing & edging','Hedge & tree trimming','Weed removal','Mulch & gravel','Sod & planting','Sprinkler & irrigation','Grading & leveling','Trenching & dirt work','Brush & stump removal','Turf & hardscape demo','Green waste hauling','Other / custom project'],
    'Pressure washing': ['One-time wash','Quarterly care plan','Not sure yet']
  };

  /* The basket is the single source of truth for what the customer has picked, across every
     service and across page loads. Chips read from it and write to it. */
  function bRead(){ try{ var v=JSON.parse(sessionStorage.getItem('dnd_basket')||'[]');
    return Array.isArray(v)?v.filter(function(x){return x&&x.svc&&x.item}):[]; }catch(e){ return []; } }
  function bWrite(a){ try{ sessionStorage.setItem('dnd_basket', JSON.stringify(a)); }catch(e){} }
  /* v10.63: match on a normalised label. The service cards say "One Large Item" while the form's
     option list says "One large item" — an exact comparison meant a pick made on a service page
     never lit its chip in the form. Casing and spacing are now ignored on both sides. */
  function nrm(t){ return String(t||'').toLowerCase().replace(/\s+/g,' ').trim().replace(/s$/,''); }   /* W10: "Large & Specialty Moves" matches its "…move" chip */
  function bFind(a,svc,item){
    return a.findIndex(function(x){ return nrm(x.svc)===nrm(svc) && nrm(x.item)===nrm(item); });
  }
  function inBasket(svc,item){ return bFind(bRead(), svc, item) >= 0; }
  function setBasket(svc,item,on){
    var a=bRead(), i=bFind(a, svc, item);
    if(on && i<0) a.push({svc:svc,item:item});
    else if(!on && i>=0) a.splice(i,1); else return;
    bWrite(a);
  }
  /* v10.84: a draft of what has been typed, so "Add more services" is not a trap. Both new links
     leave the page, and without this the customer comes back to an empty form and retypes their
     name, phone, email and description — which is worse than the scrolling problem they solve.
     Same tab only, same lifetime as the basket, and it is thrown away the moment a lead is sent. */
  var DRAFTK = 'dnd_formdraft';
  var DRAFT_FIELDS = ['contact[name]','contact[phone]','contact[email]','contact[city_zip]',
                      'contact[timing]','contact[property_type]','contact[body]'];
  function saveDraft(){
    var f = document.getElementById('quoteForm'); if(!f) return;
    try{ var d = {};
      DRAFT_FIELDS.forEach(function(n){ var el = f.querySelector('[name="' + n + '"]');
        if(el && el.value) d[n] = el.value; });
      sessionStorage.setItem(DRAFTK, JSON.stringify(d)); }catch(e){}
  }
  function restoreDraft(){
    var f = document.getElementById('quoteForm'); if(!f) return;
    try{ var d = JSON.parse(sessionStorage.getItem(DRAFTK) || 'null'); if(!d) return;
      DRAFT_FIELDS.forEach(function(n){ var el = f.querySelector('[name="' + n + '"]');
        /* Never overwrite something already on the page: a city page fills the city itself, and
           that page's own answer is the better one. */
        if(el && !el.value && d[n]) el.value = d[n]; }); }catch(e){}
  }
  window.dndSaveDraft = saveDraft;
  function chipsEl(){ return document.getElementById('optChips'); }
  function hiddenEl(){ return document.getElementById('fLoad'); }

  function updateHidden(){
    var el = chipsEl(), h = hiddenEl();
    if(!el || !h) return;
    var on = [];
    el.querySelectorAll('.chip.on').forEach(function(c){ on.push(c.textContent); });
    h.value = on.join(' + ');
  }
  /* selectChip is used by ?item= deep links; it now searches every group. */

  /* v10.61: the chip area is now MULTI-SERVICE. It renders one group per service that is either
     already in the basket or currently chosen in the dropdown, with everything the customer has
     picked already ticked. Previously it showed a single service and switching the dropdown wiped
     the rest, so a Handyman + Junk Removal job was impossible to describe from the form. */
  function basketServices(){
    var list = [], seen = {};
    bRead().forEach(function(x){ if(!seen[nrm(x.svc)]){ seen[nrm(x.svc)] = 1; list.push(x.svc); } });
    return list;
  }
  var manualSvc = '';   /* a service opened from the dropdown that has nothing ticked in it yet */
  function servicesToShow(){
    /* Map each basket service back to its canonical OPTIONS key so casing never splits a group. */
    var s = document.getElementById('fService'), keys = Object.keys(OPTIONS), list = [];
    basketServices().forEach(function(v){
      var k = keys.filter(function(kk){ return nrm(kk) === nrm(v); })[0];
      if(k && list.indexOf(k) < 0) list.push(k);
    });
    if(s && s.value && OPTIONS[s.value] && list.indexOf(s.value) < 0) list.push(s.value);
    if(manualSvc && OPTIONS[manualSvc] && list.indexOf(manualSvc) < 0) list.push(manualSvc);
    return list;
  }
  var lastChipSig = null;
  function buildChips(preserve){
    var el = chipsEl(), wrap = document.getElementById('loadWrap');
    if(!el) return;
    var svcs = servicesToShow();
    /* v10.89: same reasoning as the list box — this wipes and rebuilds every chip group, and it
       runs on the same double refresh. Identical input, identical output, so skip the churn. */
    var csig = JSON.stringify([svcs, bRead()]);
    if(csig === lastChipSig) return;
    lastChipSig = csig;
    el.innerHTML = '';
    if(!svcs.length){ if(wrap) wrap.style.display='none'; el.style.display='none'; updateHidden(); return; }
    if(wrap) wrap.style.display=''; el.style.display='';
    var multi = svcs.length > 1;
    svcs.forEach(function(svc){
      var grp = document.createElement('div');
      grp.className = 'chipgrp'; grp.dataset.svc = svc;
      if(multi){
        var h = document.createElement('p');
        h.className = 'chipgrph'; h.textContent = svc;
        grp.appendChild(h);
      }
      var row = document.createElement('div');
      row.className = 'chiprow';
      (OPTIONS[svc] || []).forEach(function(o){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'chip'; b.textContent = o;
        if(o.toLowerCase().indexOf('not sure') === 0) b.dataset.notsure = '1';
        if(inBasket(svc, o)) b.classList.add('on');
        b.addEventListener('click', function(){
          if(b.classList.contains('dis')) return;
          b.classList.toggle('on');
          applyNotSure(row, b);
          row.querySelectorAll('.chip').forEach(function(c){
            setBasket(svc, c.textContent, c.classList.contains('on')); });
          /* v10.66: the moment a chip in this service is touched, the basket takes ownership of
             it. manualSvc only exists to keep a service you OPENED from the dropdown on screen
             while it is still empty; once you have ticked in it, emptying it must close it, the
             same as a service you picked from a service page. */
          if(nrm(manualSvc) === nrm(svc)) manualSvc = '';
          updateHidden();
          /* v10.65: rebuild after the change. Unticking a service's LAST chip has to take that
             service's whole group with it — and the pressure-washing property field — instead of
             leaving an empty group stranded on screen. */
          if(window.dndRefreshForm) window.dndRefreshForm();
        });
        row.appendChild(b);
      });
      grp.appendChild(row);
      applyNotSure(row, null);
      el.appendChild(grp);
    });
    updateHidden();
  }

  function applyNotSure(el, clicked){
    var ns = el.querySelector('.chip[data-notsure]');
    if(!ns) return;
    if(clicked && !clicked.dataset.notsure && clicked.classList.contains('on')){
      ns.classList.remove('on');
    }
    if(ns.classList.contains('on')){
      el.querySelectorAll('.chip:not([data-notsure])').forEach(function(c){ c.classList.remove('on'); c.classList.add('dis'); });
    } else {
      el.querySelectorAll('.chip').forEach(function(c){ c.classList.remove('dis'); });
    }
  }
  function selectChip(text){
    var el = chipsEl();
    if(!el || !text) return false;
    var tl = text.toLowerCase(), hit = false;
    var picked = null;
    el.querySelectorAll('.chip').forEach(function(c){
      var cl = c.textContent.toLowerCase();
      if(!hit && (cl===tl || cl.indexOf(tl)===0 || tl.indexOf(cl)===0)){ c.classList.add('on'); hit = true; picked = c; }
    });
    if(picked) applyNotSure(el, picked);
    updateHidden();
    return picked ? picked.textContent : false;   /* W11: the canonical chip label, so the caller can write it to the basket */
  }

  function syncService(){
    var s = document.getElementById('fService');
    if(!s) return;
    /* v10.70: Property type is permanent now — it sits beside Service on every quote, whatever
       the service is, because access and volume depend on the property as much as the job does.
       The old show/hide (pressure washing only) is gone. */
    buildChips(false);
  }

  var svcMap={junk:'Junk removal',transport:'Transport',moving:'Moving',handyman:'Handyman',landscaping:'Landscaping',washing:'Pressure washing'};
  var itemMap={single:'One large item',quarter:'Quarter load',half:'Half load',threequarter:'Three-quarter load',full:'Full load'};

  function applyParams(p){
    var s=document.getElementById('fService'),body=document.getElementById('fBody');
    var svc=p.get('service'), name='';
    if(svc&&s){name=svcMap[svc]||svc;for(var i=0;i<s.options.length;i++)if((s.options[i].value||s.options[i].text)===name)s.selectedIndex=i;
      /* W07/W11 (v10.94): a ?service= deep link counts as OPENING the service — the same write the dropdown's
         change handler makes — so the load-time syncBasket re-picks it (the v10.69 exception) instead of
         blanking it. Only a service that actually matched an option may go on into the basket. */
      manualSvc = OPTIONS[s.value] ? s.value : '';
      if(s.value!==name) name='';
    }
    syncService();
    var it=p.get('item'), note=p.get('note');
    var want=it?(itemMap[it]||it):(note||null);
    if(want){
      var hit=selectChip(want);   /* W11: the chip's own text (canonical label) or false */
      if(hit&&name) setBasket(name, hit, true);   /* W11: the basket is the source of truth — same end state as a card tap */
      if(!hit&&body&&!body.value)body.value='RE: '+want+' — ';
    }
    /* W07: fill contact[service] now, so the pick is already committed when the load-time syncBasket runs
       (it then keeps, not clears, the pick). Ordering caveats from both fixes: do NOT move the load-time
       syncBasket ahead of restoreDraft/watchForm — the v10.84/v10.86 order is deliberate. */
    if(svc) writeServiceField();
    return !!(svc||it||note);
  }

  /* ---------- bundle mode: tap cards to select many ----------
     v10.59: the basket SURVIVES NAVIGATION. Picks are kept in sessionStorage keyed by service +
     item, so a customer can take one thing from Junk Removal, another from Landscaping and a
     third from Pressure Washing and arrive at the form with all three. Before this, the list
     lived in a page-scoped variable: leaving the page wiped it, and anything outside the first
     service was silently dropped on the way to the form. */
  var BKEY = 'dnd_basket';
  function readBasket(){
    try{ var v = JSON.parse(sessionStorage.getItem(BKEY) || '[]');
         return Array.isArray(v) ? v.filter(function(x){ return x && x.svc && x.item; }) : []; }
    catch(e){ return []; }
  }
  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  var bundle = readBasket();
  function bundleBar(){
    var b = document.getElementById('bundlebar');
    if(!b){
      b = document.createElement('button');
      b.id = 'bundlebar'; b.type = 'button';
      b.style.cssText = 'white-space:nowrap;max-width:calc(100vw - 28px);'+   /* v10.84: one line, always */
        'position:fixed;left:50%;bottom:100px;transform:translateX(-50%);z-index:2147483000;'+
        'display:none;background:#B4F000;color:#0A0C09;border:none;border-radius:999px;padding:17px 36px;cursor:pointer;'+
        'font-weight:600;font-size:15px;letter-spacing:.09em;text-transform:uppercase;'+   /* W12/W17: no inline font-family — the #bundlebar rule supplies var(--font-head) */
        'box-shadow:0 12px 32px rgba(0,0,0,.55),0 0 26px rgba(180,240,0,.5)';
      document.body.appendChild(b);
      b.addEventListener('click', openCart);
    }
    return b;
  }
  /* v10.79: the floating pill exists to carry picks TO the form. Once the form is on screen its
     job is done — the same list is already sitting inside the form, editable — so it hides. Left
     up, it read as a checkout button while people typed: tapping it opened the cart, and Continue
     scrolled them back to the top of the form, which is exactly the wrong place to land. It comes
     back the moment they scroll up to keep browsing services. */
  var formInView = false, formDecided = false, arriveLock = 0, lastTight = null, leaving = false;   /* W16: hoisted so pageshow can reset it */
  function refreshBar(){
    var b = bundleBar();
    /* v10.86: nothing shows until we know the answer. The pill used to be drawn by the basket
       restore that runs on every page load, and only corrected ~80ms later once the form had been
       measured — so on the pages whose form sits high up (Book Us, Contact) it appeared and was
       snatched away again. That was the flash on every footer link, and it was ours, not the
       browser's: the fix is to decide first and draw once. */
    if(bundle.length && !formInView && formDecided){
      b.textContent = (bundle.length === 1 ? 'Select (1) →' : 'Bundle It Up (' + bundle.length + ') →');
      if(b.classList) b.classList.remove('tight');
      b.style.display = 'block';
    } else b.style.display = 'none';
  }
  function setFormInView(v){ if(v === formInView) return; formInView = v; refreshBar(); }
  /* v10.85: "is the form on screen", not "have we reached it". The pill hides once the form is
     meaningfully in view — top above 80% of the screen — and comes back once the form has scrolled
     entirely above the viewport, because down in the map and the footer you are no longer filling
     anything in and the fastest way back to your list is the button. The two thresholds differ on
     purpose: it takes a real arrival to hide it, and a complete departure to bring it back, so it
     never strobes on and off around a single edge. */
  /* v10.90: the footer counts as "somewhere the pill must not be". It is fixed above the bottom
     of the screen, so once the footer arrives it sits on top of the links and, on a phone, you
     cannot tap what is underneath it. Reaching the footer means the customer is done with the
     page, not shopping, so the button has nothing to offer there either. */
  function footerOnScreen(){
    var f = document.querySelector('.megafooter');
    if(!f) return false;
    var h = window.innerHeight || document.documentElement.clientHeight;
    var r = f.getBoundingClientRect();
    return r.top < h - 40 && r.bottom > 0;
  }
  function formOnScreen(){
    var book = document.getElementById('book');
    if(!book) return false;
    var r = book.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    /* v10.89: 140px, not 0. A sliver of the form's bottom padding still counts as "on screen" if
       you test bottom > 0, so at the very foot of a page the button stayed hidden while the
       customer was plainly looking at the map and the footer. It now has to be meaningfully in
       view to suppress the button. */
    if(r.top < h * 0.8 && r.bottom > 140) return true;    /* the form is in front of you */
    /* v10.93: phones only. On a narrow screen the button sits over the footer and covers links you
       cannot then tap, so once you have reached the form it stays away for the rest of the page.
       On desktop there is room for it, so it comes back below the form exactly as it did before. */
    if((window.innerWidth || 9999) <= 900 && r.top < h * 0.8) return true;
    return false;
  }
  /* Pages with no form (the service index) never watch anything, so the pill keeps its old
     always-on behaviour there — that is the one place it still has a job to do.
     A scroll listener rather than an IntersectionObserver: one mechanism, one answer, and it works
     in a tab that is not painting, which rAF and observers do not. */
  function watchForm(){
    /* No form on this page (a learn page, the service index): the pill always belongs on screen,
       so the answer is known immediately. */
    /* W16: coming Back into a bfcache'd page (or returning from a mailto:/tel: click) left `leaving` stuck at
       true and the pill gone for good. pageshow(persisted) resets the flags, re-decides, and re-reads the
       basket so cards, list and pill reflect any edits made on the other page. Registered first, so form-less
       pages get it too. (W16 wrote formOnScreen() here; with W13 the decision point is decide().) */
    window.addEventListener('pageshow', function(e){
      if(!e.persisted) return;
      leaving = false; arriveLock = 0; formInView = decide(); formDecided = true; syncBasket(); });
    /* W13: no early return on form-less pages any more — the same listeners and debounce run there, and the
       decision is footer-aware on phones (the pill used to park over the footer's Book Us / Text Us on the ten
       form-less pages). Desktop is untouched: >900 always decides false, so the pill stays always-on there. */
    var noForm = !document.getElementById('book');
    function decide(){ return noForm ? ((window.innerWidth || 9999) <= 900 && footerOnScreen()) : formOnScreen(); }
    var queued = false;
    function recheck(){
      if(leaving || queued) return; queued = true;
      setTimeout(function(){
        queued = false; if(leaving) return;
        /* v10.88: while Continue is carrying you to the form, the answer is fixed at "hidden".
           Without this the smooth scroll fought the button: every scroll event on the way asked
           "is the form on screen?", the honest answer mid-flight is no, so the button reappeared
           for the length of the journey and vanished again on arrival. Disappear, pop up,
           disappear — exactly as reported. The lock lifts the moment the form is actually on
           screen, or after a ceiling in case the trip is interrupted. */
        if(arriveLock){
          if(decide() || Date.now() > arriveLock){ arriveLock = 0; setFormInView(decide()); }
          else setFormInView(true);
          return;
        }
        setFormInView(decide());
      }, 80);
    }
    /* v10.85: while the page is being left, decide nothing. Clicking a footer link fires a last
       scroll event as the document tears down, which flipped the pill visible for the instant
       before the next page painted — it read as the button flashing on every navigation. */
    function stop(){ leaving = true; var b = document.getElementById('bundlebar'); if(b) b.style.display = 'none'; }
    window.addEventListener('pagehide', stop);   /* W16: pagehide alone — it fires on every real departure (unload and bfcache entry) and never on a mailto:/tel: click */
    /* v10.89: any scroll the customer makes themselves cancels the hold at once. The hold exists
       only to stop the button flickering during OUR animation; the moment they take the wheel it
       has no business suppressing anything, which is why the button sometimes failed to come back
       when you scrolled up straight after pressing Continue. */
    function release(){ arriveLock = 0; recheck(); }
    window.addEventListener('wheel', release, {passive:true});
    window.addEventListener('touchmove', release, {passive:true});
    window.addEventListener('keydown', function(e){
      if(/^(Arrow|Page|Home|End| )/.test(e.key) || e.key === 'Spacebar') release(); });
    window.addEventListener('scroll', recheck, {passive:true});
    window.addEventListener('resize', recheck);
    window.addEventListener('hashchange', recheck);
    /* A page opened on an anchor (#book from a price card, say) starts at the top and is moved by
       the browser a moment later. Deciding immediately would show the pill and then take it away. */
    /* Measure now, before anything paints, so the very first draw is already right. A page opened
       on an anchor is the one exception: the browser moves it a moment after load, so we stay
       silent for a beat rather than answer from a position that is about to change. */
    if(location.hash){ setTimeout(function(){ formInView = decide(); formDecided = true; refreshBar(); }, 320); }
    else { formInView = decide(); formDecided = true; }
    window.addEventListener('load', recheck);
  }
  /* One place that writes every derived surface: storage, the floating counter, the lit cards,
     the list in the form, and the hidden field that actually gets submitted. */
  function markCards(){
    document.querySelectorAll('.card[data-item]').forEach(function(c){
      var on = bundle.some(function(x){ return nrm(x.svc)===nrm(c.dataset.svc) && nrm(x.item)===nrm(c.dataset.item); });
      c.classList.toggle('selected', on);
    });
  }
  /* v10.71: the chosen property type reads back at the top of the list — it is context for the
     whole job, not one of the picked items, so it gets its own row and no remove button (the
     dropdown owns it). It also resets to the placeholder whenever the list empties, so a stale
     "Single-family home" cannot sit under "Select service". */
  function propRow(){
    var p = document.getElementById('fProp');
    if(!p || !p.value) return '';
    return '<li class="bprop"><span class="bsvc">Property</span><span class="bitem">' +
           esc(p.value) + '</span><span></span></li>';
  }
  var lastBasketSig = null;
  function renderBasket(){
    var box = document.getElementById('fBasket');
    if(!box) return;
    /* v10.89: only redraw when something actually changed. This function replaces the whole Your
       list box, and a refresh runs it twice (syncBasket -> syncService -> syncBasket), so on any
       page where the form is already on screen — Book Us, Contact — the box was destroyed and
       rebuilt two to four times while you watched. Nothing moved, so layout-shift metrics saw
       nothing, but the repaint is visible, and it is the flash on the Your list square. */
    var pel0 = document.getElementById('fProp');
    var sig = JSON.stringify([bundle, pel0 ? pel0.value : '']);
    if(sig === lastBasketSig) return;
    lastBasketSig = sig;
    if(!bundle.length){ box.hidden = true; box.innerHTML = ''; return; }
    box.innerHTML = '<p class="bhead">Your list<span class="bcount">' + bundle.length +
      (bundle.length===1 ? ' item' : ' items') + '</span></p><ul class="blist">' + propRow() +
      bundle.map(function(x,i){
        return '<li><span class="bsvc">' + esc(x.svc) + '</span><span class="bitem">' + esc(x.item) +
               '</span><button type="button" class="bx" data-i="' + i + '" aria-label="Remove ' +
               esc(x.item) + '">&times;</button></li>';
      }).join('') + '</ul>' +
      /* v10.84: the way to a second service, from inside the form. Someone who has scrolled down
         here and realises they also need landscaping had no route but to scroll back up and hunt
         for the menu — most will simply not bother, and the job gets booked one service short. */
      '<a class="baddmore" href="/pages/all-services">+ Add more services</a>';
    box.hidden = false;
    var more = box.querySelector('.baddmore');
    if(more) more.addEventListener('click', saveDraft);
  }
  function writeBundleField(){
    var f = document.getElementById('fBundle');
    if(!f) return;
    f.value = bundle.length ? bundle.map(function(x){ return x.svc + ': ' + x.item; }).join('\n') : '';
  }
  /* contact[service] is DERIVED, never typed: it is the distinct services actually in the
     basket, joined. One lead, one notification, and the notification names every service. */
  /* v10.64: the visible Service bar now READS BACK the whole basket. A <select> can only display
     one of its options, so when the basket spans two or more services we keep a synthetic option
     carrying the combined label ("Moving + Pressure washing") and show that. Opening the dropdown
     still lists the real services, so another one can be added from the form. */
  /* v10.69: the Service bar reports what has been COMMITTED, never what is merely being browsed.
     Opening another service from the dropdown drops its chips in below but leaves the bar alone —
     it only gains "+ Transport" once something in Transport is actually ticked. The one exception
     is an empty list: with nothing committed there is nothing else to show, and the bar has to
     carry a real value or the required field would block the form for someone whose service has
     no chips that apply. */
  function writeServiceField(){
    var out=document.getElementById('fServiceOut'), s=document.getElementById('fService');
    var svcs=[], seen={};
    bundle.forEach(function(x){ if(!seen[nrm(x.svc)]){ seen[nrm(x.svc)]=1; svcs.push(x.svc); } });
    var label = svcs.join(' + ');
    if(out) out.value = label || (manualSvc || '');
    if(!s) return;
    var combo = s.querySelector('option[data-combo]');
    function pick(name){
      var keys = Object.keys(OPTIONS);
      var k = keys.filter(function(kk){ return nrm(kk) === nrm(name); })[0] || name;
      for(var i=0;i<s.options.length;i++){
        if((s.options[i].value||s.options[i].text) === k){ s.selectedIndex = i; return; } }
    }
    if(svcs.length > 1){
      if(!combo){ combo = document.createElement('option'); combo.setAttribute('data-combo','1');
                  s.insertBefore(combo, s.firstChild); }
      combo.value = label; combo.textContent = label; s.value = label;   /* W21: contact[service_pick] reads "A + B", not '__combo' */
      return;
    }
    if(combo) combo.remove();
    if(svcs.length === 1) pick(svcs[0]);
    else if(manualSvc && OPTIONS[manualSvc]) pick(manualSvc);
    else s.value = '';
  }
  var lastCount = null;
  function syncBasket(){
    bundle = bRead();
    /* v10.73: reset the property type only when the list TRANSITIONS to empty — i.e. the customer
       removed their last item. Resetting whenever it merely IS empty made the field impossible to
       use before picking a service: choosing one fired change -> syncBasket -> cleared instantly. */
    var pel = document.getElementById('fProp');
    if(pel && lastCount !== null && lastCount > 0 && bundle.length === 0) pel.value = '';
    lastCount = bundle.length;
    refreshBar(); markCards(); renderBasket(); writeBundleField(); writeServiceField(); renderCart();
  }
  window.dndSyncBasket = syncBasket;
  /* v10.68: order matters. syncService() builds the chip groups from the CURRENT dropdown value,
     so the bar has to be corrected first — otherwise unticking the last chip rebuilt the groups
     while the bar still pointed at the service being emptied, leaving it stranded on screen. */
  window.dndRefreshForm = function(){ syncBasket(); syncService(); syncBasket(); };
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeCart(); });
  /* v10.61: a viewable cart. The counter used to fire you straight at the form, so if you picked
     things and then wandered the site there was no way to see or edit the list without walking
     every service page again. Tapping it now opens this panel from anywhere. */
  function cartEl(){
    var c = document.getElementById('dndcart');
    if(!c){
      c = document.createElement('div');
      c.id = 'dndcart'; c.className = 'dndcart'; c.hidden = true;
      c.innerHTML = '<div class="dcback"></div><div class="dcpanel" role="dialog" aria-modal="true" aria-label="Your list">'+
        '<div class="dchead"><p class="dctitle">Your list</p>'+
        '<button type="button" class="dcx" aria-label="Close">&times;</button></div>'+
        '<div class="dcbody"></div>'+
        /* v10.84: two ways out of the list, not one. "Continue" takes you to the form; "Add more
           services" goes back to the full menu, because until now the only route to a second
           service was to remember where the service pages live. */
        '<div class="dcactions">'+
          '<a class="dcmore" href="/pages/all-services">Add more services</a>'+
          '<button type="button" class="dcgo">Continue</button>'+
        '</div></div>';
      document.body.appendChild(c);
      c.querySelector('.dcx').addEventListener('click', closeCart);
      /* Leaving the page must not cost the customer what they have already typed. */
      c.querySelector('.dcmore').addEventListener('click', saveDraft);
      c.querySelector('.dcback').addEventListener('click', closeCart);
      /* An empty list has nowhere to send you, so the button just dismisses the panel. */
      c.querySelector('.dcgo').addEventListener('click', function(){
        var empty = this.getAttribute('data-empty') === '1';
        closeCart(); if(!empty) sendBundle();
      });
    }
    return c;
  }
  function renderCart(){
    var c = document.getElementById('dndcart');
    if(!c) return;
    var b = c.querySelector('.dcbody'), list = bRead();
    var go = c.querySelector('.dcgo');
    if(!list.length){
      b.innerHTML = '<p class="dcempty">Nothing picked yet.</p>';
      go.textContent = 'Continue'; go.setAttribute('data-empty','1'); return;
    }
    go.textContent = 'Continue'; go.removeAttribute('data-empty');
    b.innerHTML = '<ul class="blist">' + propRow() + list.map(function(x,i){
      return '<li><span class="bsvc">' + esc(x.svc) + '</span><span class="bitem">' + esc(x.item) +
             '</span><button type="button" class="bx" data-ci="' + i + '" aria-label="Remove ' +
             esc(x.item) + '">&times;</button></li>'; }).join('') + '</ul>';
  }
  function openCart(){
    var c = cartEl(); renderCart(); c.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeCart(){
    var c = document.getElementById('dndcart');
    if(c) c.hidden = true;
    document.body.style.overflow = '';
  }

  function sendBundle(){
    if(!bundle.length) return;
    /* v10.87: the pill's job is over the moment Continue is pressed, so it goes now — not when the
       smooth scroll eventually brings the form into view. Waiting meant it rode down (or up) the
       screen for the length of the animation, which reads as the button following you. The scroll
       itself is untouched; only the button leaves early. Every later scroll re-decides normally,
       so it still comes back the moment the form is left behind. */
    arriveLock = Date.now() + 2500;   /* hold it hidden for the whole trip, not just the first frame */
    formInView = true; formDecided = true; refreshBar();
    var book = document.getElementById('book'), s = document.getElementById('fService');
    var svcs = [];
    bundle.forEach(function(x){ if(svcs.indexOf(x.svc) < 0) svcs.push(x.svc); });
    manualSvc = '';
    syncBasket();      /* sets the Service bar to the full combination */
    syncService();     /* then builds the chip groups for every service in it */
    syncBasket();
    /* v10.86: if this page has the form, take them to it. If it does not — a learn page, say —
       send them to Book Us, which is the page built for exactly this. It used to drop them on the
       home page, which meant arriving somewhere they did not ask for and scrolling to find it. */
    if(book) book.scrollIntoView({behavior:'smooth'});
    else location.href = '/pages/book-now';
  }

  document.addEventListener('DOMContentLoaded',function(){
    var s=document.getElementById('fService');
    var pSel=document.getElementById('fProp');
    if(pSel) pSel.addEventListener('change', function(){ syncBasket(); });
    if(s)s.addEventListener('change',function(){
      manualSvc = OPTIONS[s.value] ? s.value : '';
      if(window.dndRefreshForm) window.dndRefreshForm();
    });
    syncService();
    var had=applyParams(new URLSearchParams(location.search));
    if(had&&location.hash==='#book'){var b=document.getElementById('book');if(b)setTimeout(function(){b.scrollIntoView({behavior:'smooth'})},60);}

    // card tap OR its button = toggle selection (bundle)
    function toggleCard(card){
      var svc=card.dataset.svc, item=card.dataset.item;
      setBasket(svc, item, !inBasket(svc, item));
      syncBasket(); syncService(); syncBasket();
    }
    restoreDraft(); /* v10.84: before the basket redraws, so nothing it writes gets overwritten */
    watchForm();    /* v10.86: BEFORE the basket restore — it is what tells refreshBar the answer */
    syncBasket();   /* restore the basket on every page load: counter, lit cards, list, field */
    var qf0 = document.getElementById('quoteForm');
    if(qf0){ var dt; qf0.addEventListener('input', function(){ clearTimeout(dt); dt = setTimeout(saveDraft, 400); });
             qf0.addEventListener('change', saveDraft); }
    var qform=document.getElementById('quoteForm');
    /* v10.79: only wipe the basket when the submit is actually going through. This listener used
       to fire on every submit attempt, so a bounced validation (a typo'd email, say) quietly threw
       away everything the customer had picked — the form still showed the list until the next
       redraw, then it vanished. The validator sets data-dnd-go immediately before the real send. */
    /* v10.99 (#39): the wipe used to run the instant the POST left the browser. Shopify's spam
       challenge navigates away and can bounce the customer back, so the list and the draft were
       gone for a lead that had already passed every gate. They are now cleared on the
       confirmation page only (see the dnd_lead2 consumer below). */
    document.addEventListener('click',function(e){
      var cx=e.target.closest&&e.target.closest('#dndcart .bx');
      if(cx){ e.preventDefault(); var ci=parseInt(cx.dataset.ci,10); var cl=bRead();
              if(ci>=0 && ci<cl.length){ setBasket(cl[ci].svc, cl[ci].item, false);
                                         syncBasket(); syncService(); syncBasket(); } return; }
      var bx=e.target.closest&&e.target.closest('#fBasket .bx');
      if(bx){ e.preventDefault(); var i=parseInt(bx.dataset.i,10);
              var cur=bRead();
              if(i>=0 && i<cur.length){ setBasket(cur[i].svc, cur[i].item, false);
                                        syncBasket(); syncService(); syncBasket(); } return; }
      var buy=e.target.closest('a.buy');
      if(buy){
        var selCard=buy.closest('.card[data-item]');
        if(selCard){ e.preventDefault(); toggleCard(selCard); return; }
        var bookEl=document.getElementById('book');
        if(!bookEl)return;
        var u; try{u=new URL(buy.href, location.href)}catch(_){return}
        if(u.hash!=='#book')return;
        if(u.pathname!==location.pathname && buy.getAttribute('href').charAt(0)==='/')return;
        e.preventDefault();
        applyParams(u.searchParams);
        syncBasket();   /* W11: the deep link may have written the basket — redraw list, cards, pill, fields */
        bookEl.scrollIntoView({behavior:'smooth'});
        return;
      }
      var card=e.target.closest('.card[data-item]');
      if(card && !e.target.closest('a,button,form,input,select,textarea')){
        toggleCard(card);
      }
    });

    // nav dropdown tap support
    document.querySelectorAll('nav.mainnav .navitem').forEach(function(item){
      var link=item.querySelector(':scope > a');
      if(!link)return;
      link.addEventListener('click',function(e){
        if(window.matchMedia('(hover: none)').matches && !item.classList.contains('open')){
          e.preventDefault();
          document.querySelectorAll('nav.mainnav .navitem.open').forEach(function(o){o.classList.remove('open')});
          item.classList.add('open');
        }
      });
    });
    document.addEventListener('click',function(e){
      if(!e.target.closest('.navitem'))document.querySelectorAll('nav.mainnav .navitem.open').forEach(function(o){o.classList.remove('open')});
    });

    // transparent header over the editorial hero
    if(document.querySelector('.hero2, .hero, .onebar, .masthead')){
      document.body.classList.add('overhero');
      var scOn=false;
      var onscr=function(){var y=window.scrollY;
        if(!scOn && y>110){scOn=true;document.body.classList.add('scrolled');}
        else if(scOn && y<30){scOn=false;document.body.classList.remove('scrolled');}};
      onscr(); window.addEventListener('scroll', onscr, {passive:true});
    }

    // mobile hamburger menu
    var mm=document.getElementById('dndMobileMenu');
    var mbtns=document.querySelectorAll('[data-menubtn]');
    if(mm&&mbtns.length){
      mbtns.forEach(function(mb){
        mb.addEventListener('click',function(){
          var o=mm.classList.toggle('open');
          mbtns.forEach(function(b){b.setAttribute('aria-expanded',o?'true':'false');b.classList.toggle('isopen',o);});
          document.body.style.overflow=o?'hidden':'';
        });
      });
      mm.addEventListener('click',function(e){
        if(e.target.closest('a')){mm.classList.remove('open');mbtns.forEach(function(b){b.classList.remove('isopen');});document.body.style.overflow='';}
      });
    }

    // accordion groups inside the woven menu
    document.querySelectorAll('[data-acc]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        var acc=btn.closest('.mmacc');
        var open=acc.classList.contains('expanded');
        document.querySelectorAll('.mmacc.expanded').forEach(function(a){a.classList.remove('expanded')});
        if(!open) acc.classList.add('expanded');
      });
    });

    // photo attachments -> Cloudinary -> links into the quote email
    var aw=document.querySelector('.attachwrap');
    if(aw){
      var abtn=document.getElementById('attachBtn'), ain=document.getElementById('attachInput'),
          athumbs=document.getElementById('attachThumbs'), aph=document.getElementById('fPhotos');
      var urls=[];
      abtn.addEventListener('click',function(){ if(urls.length>=4){dndToast('4 photos max — that\'s plenty for a quote.');return;} ain.click(); });
      ain.addEventListener('change',function(){
        Array.prototype.slice.call(ain.files,0,4-urls.length).forEach(function(file){
          var chip=document.createElement('div'); chip.className='athumb loading'; athumbs.appendChild(chip);
          var img=new Image(); var rd=new FileReader();
          rd.onload=function(){ img.src=rd.result; };
          img.onload=function(){
            var c=document.createElement('canvas'); var sc=Math.min(1,1280/Math.max(img.width,img.height));
            c.width=img.width*sc; c.height=img.height*sc;
            c.getContext('2d').drawImage(img,0,0,c.width,c.height);
            chip.style.backgroundImage='url('+c.toDataURL('image/jpeg',.4)+')';
            c.toBlob(function(blob){
              var fd=new FormData(); fd.append('file',blob,'job.jpg'); fd.append('upload_preset',aw.dataset.preset);
              fetch('https://api.cloudinary.com/v1_1/'+aw.dataset.cloud+'/image/upload',{method:'POST',body:fd})
                .then(function(r){return r.json()})
                .then(function(j){
                  if(j.secure_url){ chip.dataset.url=j.secure_url; chip.classList.remove('loading');
                    urls=[]; athumbs.querySelectorAll('.athumb[data-url]').forEach(function(c){urls.push(c.dataset.url)}); aph.value=urls.join('\n'); }
                  else{ chip.remove(); dndToast('Photo upload failed — you can text them instead.'); }
                })
                .catch(function(){ chip.remove(); dndToast('Photo upload failed — you can text them instead.'); });
            },'image/jpeg',.72);
          };
          rd.readAsDataURL(file);
        });
        ain.value='';
      });
    }

    // floating label on the newsletter email field
    document.querySelectorAll('.newsfield').forEach(function(nf){
      var inp=nf.querySelector('input');
      if(!inp)return;
      var upd=function(){ nf.classList.toggle('lifted', document.activeElement===inp || inp.value.length>0); };
      inp.addEventListener('focus',upd); inp.addEventListener('blur',upd); inp.addEventListener('input',upd);
      upd();
    });

    // footer columns collapse on mobile
    document.querySelectorAll('[data-facc]').forEach(function(h){
      h.addEventListener('click',function(){
        if(window.innerWidth>700)return;
        h.closest('.fcol').classList.toggle('expanded');
      });
    });

    // reveal sections on scroll
    if(document.body.classList.contains('reveal-on')){
      var secs=document.querySelectorAll('#MainContent .shopify-section');
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){
          es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('inview');io.unobserve(en.target)}});
        },{threshold:.06});
        secs.forEach(function(el){io.observe(el)});
      } else {
        secs.forEach(function(el){el.classList.add('inview')});
      }
    }
  });
  var toastTimer;
  window.dndToast=function(msg){var t=document.getElementById('toast');if(!t)return;t.textContent=msg;t.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(function(){t.classList.remove('show')},3800);};
  document.addEventListener('shopify:section:load', function(){
    document.querySelectorAll('#MainContent .shopify-section').forEach(function(el){ el.classList.add('inview'); });
    try{ syncService(); }catch(_){}
  });
})();


/* v6.5: let the hero video run underneath the transparent header */
(function(){
  var hg = document.querySelector('.shopify-section-group-header-group');
  var hero = document.querySelector('.hero, .hero2');
  if (!hg || !hero) return;
  document.body.classList.add('videounder');
  function setH(){ document.documentElement.style.setProperty('--hdrh', hg.offsetHeight + 'px'); }
  setH();
  window.addEventListener('resize', setH);
  window.addEventListener('load', setH);
})();


/* v7.9: any page whose FIRST section has a background video/image slides under the glass header */
(function(){
  var hg = document.querySelector('.shopify-section-group-header-group');
  if (!hg || document.body.classList.contains('videounder')) {
    // hero pages already handled; still tag first-section media pages below if needed
  }
  if (!hg) return;
  var first = document.querySelector('#MainContent .shopify-section');
  if (!first) return;
  var med = first.querySelector('.secmedia');
  if (!med) return;
  var sec = med.parentElement;
  document.body.classList.add('videounder');
  sec.classList.add('undersec');
  function setH(){ document.documentElement.style.setProperty('--hdrh', hg.offsetHeight + 'px'); }
  setH();
  window.addEventListener('resize', setH);
  window.addEventListener('load', setH);
})();


/* W18: one shared answer to "should the background video hold still?" — the site's Reduce Motion toggle (stored
   under dnd_a11y) or the OS preference. Read by nudgeplay (v8.0b), kick (v10.40) and the a11y panel's apply(). */
window.dndNoMotion=function(){var st={};try{st=JSON.parse(localStorage.getItem('dnd_a11y')||'{}')||{};}catch(e){}return !!st.motion||(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches);};

/* v8.0b: some phones (low-power mode) block autoplay — nudge videos on first touch */
(function(){
  function nudgeplay(){
    document.querySelectorAll('.secmedia video,.hero video').forEach(function(v){
      if (v.paused && !window.dndNoMotion()) { v.muted = true; v.play().catch(function(){}); }   /* W18 */
    });
  }
  nudgeplay();
  ['touchstart','click','scroll'].forEach(function(ev){
    window.addEventListener(ev, nudgeplay, { once: true, passive: true });
  });
})();


/* v10.3: REAL submit (deliverability first) + validation + post-reload lead capture */
(function(){
  var form = document.getElementById('quoteForm');
  /* v10.81: the browser keeps the gate; we only replace its speech bubble.
     v10.80 set form.noValidate and moved every check into this script. That was wrong. It made one
     cached or broken copy of this file enough to let an empty form through, which is exactly what
     happened: a tab still holding the pre-v10.79 page submitted with no property type and no
     description. The `required` attributes are the only guard that survives stale JS, so they do
     the blocking again. What we add is the part the browser is bad at: preventDefault on the
     `invalid` event kills the native bubble — which names a field the customer may not be looking
     at and erases itself a second later — and we paint our own red field, note, summary line and
     toast in its place. Blocking and explaining are now two different jobs. */
  var modal = document.getElementById('sentModal');
  var lead = document.getElementById('leadForm');

  // After a successful submit the page reloads with the modal shown server-side:
  // that's our cue to file the lead (stashed pre-submit) into Customers, quietly.
  if (modal && modal.classList.contains('show')) {
    try {
      var saved = JSON.parse(sessionStorage.getItem('dnd_lead') || 'null');
      var aw = document.querySelector('.attachwrap');
      if (saved && saved.email && aw && aw.dataset.cloud) {
        var lc = document.createElement('canvas'); lc.width = 2; lc.height = 2;
        lc.getContext('2d').fillRect(0, 0, 2, 2);
        lc.toBlob(function(blob){
          var fd = new FormData();
          fd.append('file', blob, 'lead.png');
          fd.append('upload_preset', aw.dataset.preset);
          fd.append('folder', 'dndleads');
          fd.append('tags', 'dndlead');
          var clean = function(s){ return String(s || '').replace(/[|=]/g, ' ').trim(); };
          fd.append('context', 'email=' + clean(saved.email) + '|name=' + clean(saved.name) +
            '|phone=' + clean(saved.phone) + '|svc=' + clean(saved.service) + '|city=' + clean(saved.city));
          fetch('https://api.cloudinary.com/v1_1/' + aw.dataset.cloud + '/image/upload', {method: 'POST', body: fd})
            .catch(function(){});
          // (v10.53) the owner alert now fires from the Ops beacon below, with a tap-through to the lead
        }, 'image/png');
      }
    } catch (e) {}
    sessionStorage.removeItem('dnd_lead');
  }

  if (!form) return;
  var checking = false, cleared = false;

  function setErr(input, msg){
    input.classList.add('fielderr');
    var note = input.parentElement.querySelector('.errnote');
    if (!note) { note = document.createElement('span'); note.className = 'errnote'; input.parentElement.appendChild(note); }
    note.textContent = msg;
  }
  function clearErr(input){
    input.classList.remove('fielderr');
    var note = input.parentElement.querySelector('.errnote');
    if (note) note.remove();
  }
  /* v10.79: the item chips are not a form control — they write to a hidden input, and a hidden
     input is barred from constraint validation — so they get their own error surface, styled the
     same as a field error and placed directly under the row. */
  function setGroupErr(el, msg){
    if(!el) return;
    el.classList.add('fielderr');
    var note = el.parentElement.querySelector('.errnote.grouperr');
    if(!note){ note = document.createElement('span'); note.className = 'errnote grouperr';
               el.parentElement.insertBefore(note, el.nextSibling); }
    note.textContent = msg;
  }
  function clearGroupErr(el){
    if(!el) return;
    el.classList.remove('fielderr');
    var note = el.parentElement.querySelector('.errnote.grouperr');
    if(note) note.remove();
  }
  /* v10.88: the free half of "is this a real number". North American numbering has hard rules, so
     some ten-digit strings are not numbers at all, the way no street has a floor minus four. This
     rejects ONLY the impossible — it is deliberately blind to whether a possible number is in
     service or belongs to the person, because every check that guesses at that eventually turns a
     real customer away, and one lost job costs more than every fake lead combined. */
  function realUsNumber(d){
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    if (d.length !== 10) return false;
    var npa = d.slice(0,3), nxx = d.slice(3,6), line = d.slice(6);
    if (npa.charAt(0) === '0' || npa.charAt(0) === '1') return false;   // no area code starts 0 or 1
    if (nxx.charAt(0) === '0' || nxx.charAt(0) === '1') return false;   // nor any exchange
    if (npa.charAt(1) === '1' && npa.charAt(2) === '1') return false;   // 211, 311 … 911 are services
    if (nxx.charAt(1) === '1' && nxx.charAt(2) === '1') return false;
    if (nxx === '555' && +line >= 100 && +line <= 199) return false;    // the block reserved for fiction
    return true;
  }
  var BAD_DOMAINS = /^(test|example|fake|asdf|abc|aaa|mailinator|guerrillamail|tempmail|10minutemail|trashmail|yopmail)\./i;
  /* v10.88: exact-match typos only, never fuzzy guessing. This one blocks the submit to ask
     "did you mean…", so a wrong guess would turn away a real customer — and unlike everything
     else here it WINS jobs: a mistyped address means our reply bounces and the customer never
     learns we answered. Every entry below is a real misspelling of a large provider. */
  var TYPOS = {
    'gmial.com':'gmail.com','gmal.com':'gmail.com','gamil.com':'gmail.com','gnail.com':'gmail.com',
    'gmai.com':'gmail.com','gmil.com':'gmail.com','gmali.com':'gmail.com','gmaul.com':'gmail.com',
    'gmaill.com':'gmail.com','gmail.con':'gmail.com','gmail.co':'gmail.com','gmail.cm':'gmail.com',
    'gmail.om':'gmail.com','gmail.comm':'gmail.com','gmail.cim':'gmail.com','gmail.xom':'gmail.com',
    'gmail.vom':'gmail.com','gmailc.om':'gmail.com','ggmail.com':'gmail.com','gmail.ocm':'gmail.com',
    'yaho.com':'yahoo.com','yahooo.com':'yahoo.com','yhaoo.com':'yahoo.com','yaoo.com':'yahoo.com',
    'yahho.com':'yahoo.com','yahoo.con':'yahoo.com','yahoo.co':'yahoo.com','yahoo.cm':'yahoo.com',
    'yahoo.om':'yahoo.com','yahoo.ocm':'yahoo.com',
    'hotmial.com':'hotmail.com','hotmai.com':'hotmail.com','hotmil.com':'hotmail.com',
    'hotamil.com':'hotmail.com','hotmaill.com':'hotmail.com','hotmail.con':'hotmail.com',
    'hotmail.co':'hotmail.com','hotmail.cm':'hotmail.com','hotmail.om':'hotmail.com',
    'outlok.com':'outlook.com','outllok.com':'outlook.com','outook.com':'outlook.com',
    'oultook.com':'outlook.com','outlook.con':'outlook.com','outlook.co':'outlook.com',
    'outlook.cm':'outlook.com','outlok.co':'outlook.com',
    'iclould.com':'icloud.com','iclod.com':'icloud.com','icoud.com':'icloud.com',
    'icloud.con':'icloud.com','icloud.co':'icloud.com','iclou.com':'icloud.com',
    'aol.con':'aol.com','aoll.com':'aol.com','aol.co':'aol.com',
    'live.con':'live.com','live.co':'live.com','msn.con':'msn.com',
    'comcst.net':'comcast.net','comcast.ne':'comcast.net',
    'sbcglobal.com':'sbcglobal.net',   /* W04 (v10.94): ao.com, comcast.com, verizon.com and att.com are real domains — they now fall through to checkMX */
    'me.con':'me.com','mac.con':'mac.com','protonmai.com':'protonmail.com','portonmail.com':'protonmail.com'
  };
  function checkMX(domain){
    var ac = new AbortController();               /* W05: never let a stalled DoH lookup pin the button on 'Checking…' */
    setTimeout(function(){ ac.abort(); }, 2500);  /* abort -> catch -> true (fail-open, as today) */
    return fetch('https://dns.google/resolve?name=' + encodeURIComponent(domain) + '&type=MX', {signal: ac.signal})
      .then(function(r){ return r.json(); })
      .then(function(d){ return !!(d.Answer && d.Answer.length); })
      .catch(function(){ return true; });
  }
  var FIELD_LABEL = { 'fService':'Please select a service.',
    'fProp':'Please select a property type.', 'fTiming':'Please select your timing.',
    'fBody':'Please tell us a little about the project.',
    'contact[name]':'Please enter your name.', 'contact[phone]':'Please enter your phone number.',
    'contact[email]':'Please enter your email address.', 'contact[city_zip]':'Please enter your city.' };
  function msgFor(el){
    var v = el.validity || {};
    if (v.valueMissing) return FIELD_LABEL[el.id] || FIELD_LABEL[el.name] || 'Please fill this in.';
    if (v.typeMismatch) return 'Please enter a valid email address.';
    return 'Please check this field.';
  }
  /* The first error in DOM order is the one nearest the top of the form, which is where the
     customer should be sent — regardless of the order the checks happen to run in. */
  function firstError(){
    var fe = form.querySelector('.fielderr');
    if(!fe) return null;
    var note = fe.parentElement && fe.parentElement.querySelector('.errnote');
    return { el: fe, msg: note ? note.textContent : 'Please finish this field.' };
  }
  /* v10.91: this used to draw a red line above the send button naming the first problem. It said
     exactly what the toast at the bottom of the screen already says, and what the field itself
     already shows in red, so it was the third copy of one message. Kept as a remover so any box
     left over from a previous version is cleared. */
  function showSummary(n, msg){
    var btn = form.querySelector('button[type="submit"]');
    if(!btn) return;
    var box = form.querySelector('.formsummary');
    if(box) box.remove();
    return;
    /* eslint-disable no-unreachable */
    if(!n){ if(box) box.remove(); return; }
    if(!box){ box = document.createElement('p'); box.className = 'formsummary';
              box.setAttribute('role','alert');
              btn.parentElement.insertBefore(box, btn); }
    /* v10.84: two spans, not one sentence. On a phone the count pushed this onto a second line,
       which made a one-line warning look like a paragraph; the phone now shows the instruction
       only and the count rides along on wider screens, where there is room for it. */
    box.innerHTML = '';
    var main = document.createElement('span'); main.className = 'fsmain'; main.textContent = msg;
    box.appendChild(main);
    if(n > 1){
      var more = document.createElement('span'); more.className = 'fsmore';
      more.textContent = ' ' + (n - 1) + (n === 2 ? ' other field also needs' : ' other fields also need') + ' attention.';
      box.appendChild(more);
    }
  }
  function validateSync(){
    var ok = true;
    var name = form.querySelector('[name="contact[name]"]');
    var phone = form.querySelector('[name="contact[phone]"]');
    var email = form.querySelector('[name="contact[email]"]');
    [name, phone, email].forEach(clearErr);
    var raw = (name.value || '').trim();
    var words = raw.split(/\s+/).filter(function(w){ return w.length >= 2; });
    if (words.length < 2 || raw.replace(/[^A-Za-z\u00C0-\u024F\u1E00-\u1EFF]/g, '').length < 5 ||
        !/^[A-Za-z\u00C0-\u024F\u1E00-\u1EFF'. -]+$/.test(raw)) {   /* W00: Vietnamese tone-marked letters (Latin Extended Additional) and the period pass; the two-word gate already guarantees 4 letters */
      setErr(name, 'Please enter your real full name (first and last).'); ok = false; }
    var digits = (phone.value || '').replace(/\D/g, '');
    if (digits.length < 10 || digits.length > 11 || /^(\d)\1{9}/.test(digits) || !realUsNumber(digits)) {
      setErr(phone, 'Please enter a valid US phone number.'); ok = false; }
    var em = (email.value || '').trim().toLowerCase();
    var dom = em.split('@')[1] || '';
    if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(em) || BAD_DOMAINS.test(dom)) {
      setErr(email, 'Please enter a valid email address.'); ok = false; }
    else if (TYPOS[dom]) { setErr(email, 'Did you mean @' + TYPOS[dom] + '?'); ok = false; }

    /* v10.79: every field that describes the job is required. The four selects/description carry
       the native `required` attribute, so an empty one never even reaches this function — these
       checks are the backstop for the cases the attribute cannot cover: a value cleared by script,
       a whitespace-only description, and the item chips. Every service's chip list ends in a
       "Not sure" option, so requiring a pick can never dead-end a customer. */
    var city  = form.querySelector('[name="contact[city_zip]"]');
    if (city) { clearErr(city);
      if (!(city.value || '').trim()) { setErr(city, 'Please enter your city.'); ok = false; } }
    var svc   = form.querySelector('#fService');
    var prop  = form.querySelector('#fProp');
    var tim   = form.querySelector('#fTiming');
    var bodyEl= form.querySelector('#fBody');
    var chips = document.getElementById('optChips');
    var load  = form.querySelector('[name="contact[option]"]');
    var picked= form.querySelector('[name="contact[bundle]"]');
    [svc, prop, tim, bodyEl].forEach(function(el){ if(el) clearErr(el); });
    clearGroupErr(chips);
    if (svc && !(svc.value || '').trim())  { setErr(svc,  'Please select a service.'); ok = false; }
    if (prop && !(prop.value || '').trim()){ setErr(prop, 'Please select a property type.'); ok = false; }
    if (tim && !(tim.value || '').trim())  { setErr(tim,  'Please select your timing.'); ok = false; }
    if (bodyEl && !(bodyEl.value || '').trim()) {
      setErr(bodyEl, 'Please tell us a little about the project.'); ok = false; }
    var hasItems = !!((picked && picked.value || '').trim()) || !!((load && load.value || '').trim());
    var chipsUp  = chips && chips.style.display !== 'none' && chips.querySelector('.chip');
    if (chipsUp && !hasItems) {
      setGroupErr(chips, 'Please pick at least one — tap “Not sure” if you aren\u2019t certain.'); ok = false; }
    return ok;
  }

  /* One place decides what a failed attempt looks like, so the native path and our own checks
     behave identically: name the topmost problem above the button, say it again at the bottom of
     the screen, and put the field itself on screen. */
  function afterFail(){
    var f = firstError();
    if (!f) return;
    showSummary(form.querySelectorAll('.fielderr').length, f.msg);
    if (/^(INPUT|TEXTAREA)$/.test(f.el.tagName)) { try{ f.el.focus({preventScroll:true}); }catch(_){ } }
    if (f.el.scrollIntoView) f.el.scrollIntoView({behavior:'smooth', block:'center'});
    if (window.dndToast) window.dndToast(f.msg);
  }
  /* Every invalid field fires this during the browser's own check. Cancelling it removes the
     native bubble and nothing else — the form is still blocked, which is the point. They all fire
     synchronously, so one timeout after the burst gives us the complete picture to summarise. */
  var burst = false;
  form.addEventListener('invalid', function(e){
    e.preventDefault();
    setErr(e.target, msgFor(e.target));
    if (!burst) { burst = true; setTimeout(function(){ burst = false; afterFail(); }, 0); }
  }, true);
  /* Clear the previous attempt before the browser re-checks: a field that has since been filled
     fires no `invalid` event, so its old red state would otherwise stay behind for ever. */
  /* v10.99 (#41): remember the campaign the visitor arrived on, so it survives the hop to
     another service page and back. Written once per landing, read at submit. */
  try{ var dndSrc = new URLSearchParams(location.search).get('src'); if(dndSrc) sessionStorage.setItem('dnd_src', dndSrc); }catch(e){}
  var sbtn = form.querySelector('button[type="submit"]');
  /* v10.99 (#40): a bfcache restore (Back from Shopify's /challenge or the confirmation page)
     brings the DOM and this closure back exactly as they were left: button disabled, label
     'Sending…', cleared=true — a form that can never be sent again. Reset the send state.
     data-dnd-go must go too, or the next bounced validation would clear the basket. */
  var dndSubmitLabel = sbtn ? sbtn.textContent : '';
  window.addEventListener('pageshow', function(e){
    if(!e.persisted) return;
    cleared = false; checking = false;
    form.removeAttribute('data-dnd-go');
    if(sbtn){ sbtn.disabled = false; sbtn.textContent = dndSubmitLabel; }
  });
  if (sbtn) sbtn.addEventListener('click', function(){
    [].forEach.call(form.querySelectorAll('.fielderr'), function(el){
      if (el.id === 'optChips') clearGroupErr(el); else clearErr(el); });
    showSummary(0);
  });

  form.addEventListener('submit', function(e){
    if (cleared) return;                      // validated — let the real submit go
    e.preventDefault();
    if (checking) return;
    showSummary(0);
    /* Reached only when the browser is already satisfied, so this covers what an attribute cannot:
       a real full name, a reachable email, a description that is more than spaces, and the item
       chips — which write to a hidden input the browser refuses to validate at all. */
    if (!validateSync()) { afterFail(); return; }
    checking = true;
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Checking…'; }
    var email = form.querySelector('[name="contact[email]"]');
    var dom = email.value.trim().toLowerCase().split('@')[1];
    checkMX(dom).then(function(valid){
      checking = false;
      if (!valid) {
        setErr(email, "That email's domain can't receive mail — double-check it.");
        if (btn) { btn.disabled = false; btn.textContent = label; }
        email.focus(); return;
      }
      try {
        sessionStorage.setItem('dnd_lead', JSON.stringify({
          name: form.querySelector('[name="contact[name]"]').value.trim(),
          email: email.value.trim(),
          phone: form.querySelector('[name="contact[phone]"]').value.replace(/\D/g, ''),
          service: (form.querySelector('[name="contact[service]"]') || {}).value || '',
          city: (form.querySelector('[name="contact[city_zip]"]') || {}).value || ''
        }));
      } catch (err) {}
      if (btn) { btn.textContent = 'Sending…'; }
      cleared = true;
      form.setAttribute('data-dnd-go','1');   /* v10.79: now the basket may be cleared */
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
})();


/* v10.7: standalone reveal-on-scroll safety net — a second, independent observer so a
   failure anywhere else in this file can never leave sections invisible */
(function(){
  function arm(){
    if(!document.body.classList.contains('reveal-on')) return;
    var secs=document.querySelectorAll('#MainContent .shopify-section');
    if(!('IntersectionObserver' in window)){secs.forEach(function(el){el.classList.add('inview')});return;}
    var io=new IntersectionObserver(function(es){
      es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('inview');io.unobserve(en.target)}});
    },{threshold:.06});
    secs.forEach(function(el){io.observe(el)});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',arm);else arm();
})();


/* v10.9: pause the city tape on touch; tap a photo chip to remove it */
(function(){
  var tape = document.querySelector('.tape');
  if (tape) {
    var t;
    tape.addEventListener('touchstart', function(){
      tape.classList.add('tpause');
      clearTimeout(t); t = setTimeout(function(){ tape.classList.remove('tpause'); }, 4000);
    }, {passive: true});
  }
  var thumbs = document.getElementById('attachThumbs'), aph = document.getElementById('fPhotos');
  if (thumbs && aph) {
    thumbs.addEventListener('click', function(e){
      var chip = e.target.closest('.athumb');
      if (!chip || chip.classList.contains('loading')) return;
      chip.remove();
      var left = [];
      thumbs.querySelectorAll('.athumb[data-url]').forEach(function(c){ left.push(c.dataset.url); });
      aph.value = left.join('\n');
    });
  }
})();


/* v10.11: hero entrance failsafe — whatever happens, the hero is fully visible by 5s */
(function(){
  var c = document.querySelector('.hero .content');
  if (!c) return;
  setTimeout(function(){ c.classList.add('heroanim-done'); }, 8000);
})();


/* v10.14: dust puffs live OUTSIDE the buttons so nothing clips them */
(function(){
  var stack = document.querySelector('.hero .ctastack');
  if (!stack) return;
  function place(){
    stack.querySelectorAll('.herodust').forEach(function(d){ d.remove(); });
    stack.querySelectorAll('.btn').forEach(function(b, i){
      var d = document.createElement('span');
      d.className = 'herodust' + (i ? ' d2' : '');
      d.style.top = (b.offsetTop + b.offsetHeight - 10) + 'px';
      d.style.left = (b.offsetLeft + b.offsetWidth / 2) + 'px';
      stack.appendChild(d);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
})();

/* ============ v10.22: mobile drawer — tap anywhere closes, page scroll stays free ============ */
(function(){
  var boot=function(){
    var mm=document.getElementById('dndMobileMenu');
    if(!mm) return;
    var openedAt=0;
    var isOpen=function(){return mm.classList.contains('open');};
    var closeMenu=function(){
      mm.classList.remove('open');
      document.querySelectorAll('[data-menubtn]').forEach(function(b){b.classList.remove('isopen');b.setAttribute('aria-expanded','false');});
      document.body.style.overflow='';
    };
    // the original toggle locks body scroll on open; this bubble-phase listener runs after it and undoes the lock
    document.addEventListener('click',function(e){
      if(e.target.closest&&e.target.closest('[data-menubtn]')){document.body.style.overflow='';openedAt=Date.now();}
    });
    // tap anywhere outside the panel closes it (and swallows that tap so nothing underneath fires)
    document.addEventListener('click',function(e){
      if(!isOpen()) return;
      if(mm.contains(e.target)) return;
      if(e.target.closest&&e.target.closest('[data-menubtn]')) return;
      e.preventDefault(); e.stopPropagation();
      closeMenu();
    },true);
    // a scroll or touch-drag outside the panel closes it too, then the page scrolls freely
    window.addEventListener('scroll',function(){
      if(isOpen()&&Date.now()-openedAt>350) closeMenu();
    },{passive:true});
    document.addEventListener('touchmove',function(e){
      if(isOpen()&&!mm.contains(e.target)) closeMenu();
    },{passive:true});
  };
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();

/* ============ v10.24: side-drawer page overlay, synced to the menu's open state ============ */
(function(){
  var boot=function(){
    var mm=document.getElementById('dndMobileMenu');
    if(!mm) return;
    var bd=document.createElement('div');
    bd.className='dndbackdrop';
    document.body.appendChild(bd);
    var sync=function(){ bd.classList.toggle('show', mm.classList.contains('open')); };
    new MutationObserver(sync).observe(mm,{attributes:true,attributeFilter:['class']});
    sync();
  };
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();

/* ============ v10.25: free the drawer from the header's stacking context + accessibility widget ============ */
(function(){
  var boot=function(){
    /* (a) the header section wrapper has z-index:80, which trapped the drawer's z:96 UNDER
       the body-level backdrop (z:94) — dimmed and unclickable. Reparent the drawer to body. */
    var mm=document.getElementById('dndMobileMenu');
    if(mm && mm.parentElement!==document.body) document.body.appendChild(mm);

    /* (b) accessibility widget */
    if(document.querySelector('.a11ybtn')) return;
    var KEY='dnd_a11y';
    var FLAGS=[['bigtext','Bigger Text'],['contrast','High Contrast'],['links','Underline Links'],['motion','Reduce Motion']];
    var state={};
    try{ state=JSON.parse(localStorage.getItem(KEY)||'{}')||{}; }catch(e){ state={}; }
    var btn=document.createElement('button');
    btn.className='a11ybtn'; btn.type='button';
    btn.setAttribute('aria-label','Accessibility options'); btn.setAttribute('aria-expanded','false');
    btn.innerHTML='<svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true"><circle cx="12" cy="4.4" r="2.1"/><path d="M12 8.1c-2.7 0-5.2-.4-7.3-.9l-.5 1.9c1.7.4 3.5.7 5.3.8v3.3l-2.1 7.2 1.9.6 2.2-6.5h1l2.2 6.5 1.9-.6-2.1-7.2v-3.3c1.8-.1 3.6-.4 5.3-.8l-.5-1.9c-2.1.5-4.6.9-7.3.9z"/></svg>';
    var panel=document.createElement('div');
    panel.className='a11ypanel'; panel.hidden=true;
    panel.setAttribute('role','dialog'); panel.setAttribute('aria-label','Accessibility options');
    panel.innerHTML='<p class="a11yhead">Accessibility</p>'+
      FLAGS.map(function(f){return '<button type="button" data-a11y="'+f[0]+'" aria-pressed="false"><span class="a11ydot"></span>'+f[1]+'</button>';}).join('')+
      '<button type="button" class="a11yreset">Reset All</button>';
    document.body.appendChild(btn); document.body.appendChild(panel);
    var apply=function(){
      FLAGS.forEach(function(f){ document.body.classList.toggle('a11y-'+f[0], !!state[f[0]]); });
      panel.querySelectorAll('[data-a11y]').forEach(function(b){
        var on=!!state[b.getAttribute('data-a11y')];
        b.classList.toggle('on',on); b.setAttribute('aria-pressed',on?'true':'false');
      });
      try{ localStorage.setItem(KEY,JSON.stringify(state)); }catch(e){}
      /* W18: Reduce Motion (site toggle or OS setting) stops the looping background video; switching it off
         resumes it. Runs at boot and on every panel click. Placed AFTER the localStorage write on purpose:
         dndNoMotion() reads the stored state, so the slot the fix text named (before the panel sync, i.e. before
         the write) would have answered from the PREVIOUS state on every click. */
      var still=window.dndNoMotion();document.querySelectorAll('video.dndvid').forEach(function(v){if(still){v.pause();v.removeAttribute('autoplay');}else{v.setAttribute('autoplay','');var p=v.play();if(p&&p.catch)p.catch(function(){});}});
    };
    var setOpen=function(o){ panel.hidden=!o; btn.setAttribute('aria-expanded',o?'true':'false'); btn.classList.toggle('isopen',o); document.body.classList.toggle('a11y-open',o); };   /* W15: the CSS hides the pill while the panel is open */
    btn.addEventListener('click',function(e){ e.stopPropagation(); setOpen(panel.hidden); });
    panel.addEventListener('click',function(e){
      var t=e.target.closest('[data-a11y]');
      if(t){ var k=t.getAttribute('data-a11y'); state[k]=!state[k]; apply(); return; }
      if(e.target.closest('.a11yreset')){ state={}; apply(); }
    });
    document.addEventListener('click',function(e){
      if(!panel.hidden && !panel.contains(e.target) && !btn.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!panel.hidden) setOpen(false); });
    apply();
  };
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();

/* ============ v10.29: three more accessibility toggles (font, spacing, cursor) ============ */
(function(){
  var boot=function(){
    var panel=document.querySelector('.a11ypanel');
    if(!panel || panel.querySelector('[data-a11y="font"]')) return;
    var EXTRA=[['font','Readable Font'],['spacing','Text Spacing'],['cursor','Big Cursor']];
    var reset=panel.querySelector('.a11yreset');
    EXTRA.forEach(function(f){
      var b=document.createElement('button');
      b.type='button'; b.setAttribute('data-a11y',f[0]); b.setAttribute('aria-pressed','false');
      b.innerHTML='<span class="a11ydot"></span>'+f[1];
      panel.insertBefore(b,reset);
    });
    /* the v10.25 panel handler already toggles + persists any [data-a11y] key;
       this keeps the BODY classes for the new keys in sync with stored state */
    var syncBody=function(){
      var st={};
      try{ st=JSON.parse(localStorage.getItem('dnd_a11y')||'{}')||{}; }catch(e){}
      EXTRA.forEach(function(f){
        document.body.classList.toggle('a11y-'+f[0], !!st[f[0]]);
        var b=panel.querySelector('[data-a11y="'+f[0]+'"]');
        if(b){ b.classList.toggle('on', !!st[f[0]]); b.setAttribute('aria-pressed', st[f[0]]?'true':'false'); }
      });
    };
    panel.addEventListener('click',function(){ setTimeout(syncBody,0); });
    syncBody();
  };
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();

/* ============ v10.34: footer accordion — only one group open at a time ============ */
document.addEventListener('click',function(e){
  var h=e.target.closest&&e.target.closest('[data-facc]');
  if(!h||window.innerWidth>700)return;
  var col=h.closest('.fcol');
  if(col&&col.classList.contains('expanded')){
    document.querySelectorAll('.fcol.expanded').forEach(function(c){ if(c!==col)c.classList.remove('expanded'); });
  }
});

/* ============ v10.40: autoplay resilience only — sources are chosen in the HTML/inline script ============ */
(function(){
  var boot=function(){
    var vids=document.querySelectorAll('video.dndvid');
    if(!vids.length) return;
    var tryPlay=function(v){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); };
    var kick=function(){ if(window.dndNoMotion()) return; vids.forEach(function(v){ if(v.paused) tryPlay(v); }); };   /* W18 */
    kick();
    document.addEventListener('visibilitychange',function(){ if(!document.hidden) kick(); });
    ['touchstart','click','scroll'].forEach(function(ev){ window.addEventListener(ev,kick,{once:true,passive:true}); });
  };
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();

/* ============ v10.48 -> v10.55: footer panels CENTRE under their own tab on phones ============
   v10.48 pinned each panel's LEFT edge to its tab's left edge. v10.55 centres the panel on the
   tab instead, still clamped inside the grid. Because the clamp bites on the two edge tabs, this
   leaves Company (flush left) and Services (right-aligned by CSS) exactly where they already are,
   and re-centres Learn and Get In Touch. Measurement now includes .fbtns / .socialrow, which have
   no direct <a> children -- that omission is why the Get In Touch panel used to sprawl. */
(function(){
  var grid=document.querySelector('.megafooter .fgrid.five'); if(!grid)return;
  function panelWidth(k){
    var w=0;
    k.style.whiteSpace='nowrap';
    k.querySelectorAll(':scope > a').forEach(function(a){ w=Math.max(w,a.getBoundingClientRect().width); });
    k.style.whiteSpace='';
    k.querySelectorAll(':scope > .fbtns, :scope > .socialrow').forEach(function(el){ w=Math.max(w,el.getBoundingClientRect().width); });
    return w;
  }
  function place(){
    var kids=grid.querySelectorAll('.fkids');
    if(window.innerWidth>700){kids.forEach(function(k){k.style.removeProperty('--fx');});return;}
    var g=grid.getBoundingClientRect();
    grid.querySelectorAll('.fcol').forEach(function(c){
      var h=c.querySelector('.fhead[data-facc]'),k=c.querySelector('.fkids'); if(!h||!k)return;
      k.style.setProperty('--fx','0px');
      var hr=h.getBoundingClientRect(), w=panelWidth(k);
      var fx=Math.min(hr.left+hr.width/2-g.left-w/2, Math.max(0,g.width-w));
      k.style.setProperty('--fx',Math.max(0,Math.round(fx))+'px');
      /* v10.78: publish the panel's real height so the open/close animation is exact. The CSS
         animated max-height 0 -> 640px, but a panel is only ~120-200px tall, so closing spent
         most of the .45s shrinking invisible space before anything moved, then snapped — and
         with two panels swapping at once that read as lag. */
      k.style.setProperty('--fh',(k.scrollHeight+12)+'px');
      /* v10.57: also publish the measured width. Without it a panel's content box runs to the
         footer's right edge, so centring the TEXT inside centres it on the box, not on the tab. */
      k.style.setProperty('--fw',Math.ceil(w)+'px');   /* v10.99 (#52): rounding DOWN could clip the widest link into two lines */
    });
  }
  place();
  /* v10.99 (#60): place() reads getBoundingClientRect per link with a whiteSpace toggle — about
     16 forced layouts a call. An unthrottled resize fires that on every frame while the phone's
     URL bar collapses mid-scroll, where only the height changed and nothing needs re-measuring. */
  var dndPW = window.innerWidth, dndPT = 0;
  window.addEventListener('resize',function(){
    if(window.innerWidth === dndPW) return;
    dndPW = window.innerWidth;
    clearTimeout(dndPT); dndPT = setTimeout(place,150);
  },{passive:true});
  window.addEventListener('orientationchange',place);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(place);
  document.addEventListener('click',function(e){ if(e.target.closest&&e.target.closest('[data-facc]'))place(); });
})();

/* ============ v10.52: website lead → Ops pipeline (lead.create) ============
   A second stash is written on submit (the v10.3 block clears its own), and after the
   post-submit reload the lead is POSTed to the Ops API from the visitor's browser
   (text/plain, no preflight). Dedupe is server-side (same email/phone within 1 h). */
(function(){
  var form=document.getElementById('quoteForm'), modal=document.getElementById('sentModal');
  var val=function(sel){ var el=form&&form.querySelector(sel); return el?String(el.value||'').trim():''; };
  if(form){
    form.addEventListener('submit',function(){
      /* v10.83: only stash a lead that is really being sent. This listener is on the CAPTURE
         phase, so it used to run before any validation on EVERY attempt — a blocked submit with
         empty fields still left its half-filled copy in sessionStorage, and the next submission
         that did go through shipped that stale copy to the phone and into the CRM. That is why an
         alert could name blanks the customer had already corrected, and why the captcha round-trip
         looked like it "bypassed" the form: the alert never came from what Shopify saved, it came
         from here. data-dnd-go is set by the validator immediately before the real send, and
         checkValidity is the browser's own verdict — both must agree. */
      if(form.getAttribute('data-dnd-go') !== '1') return;
      if(form.checkValidity && !form.checkValidity()) return;
      try{
        var parts=[]; var body=val('[name="contact[body]"]'); if(body)parts.push(body);
        var timing=val('[name="contact[timing]"]'); if(timing)parts.push('Timing: '+timing);
        var ptype=val('[name="contact[property_type]"]'); if(ptype)parts.push('Property: '+ptype);
        var load=val('[name="contact[option]"]');
        var picked=val('[name="contact[bundle]"]');
        /* The basket already names every service and item, so don't repeat it as "Load:". */
        if(picked) parts.push(picked); else if(load) parts.push('Load: '+load);
        sessionStorage.setItem('dnd_lead2',JSON.stringify({
          name:val('[name="contact[name]"]'), email:val('[name="contact[email]"]'),
          phone:val('[name="contact[phone]"]').replace(/\D/g,''), service:val('[name="contact[service]"]'),
          city:val('[name="contact[city_zip]"]'), load_size:load, details:parts.join('\n'),
          property:ptype, timing:timing, body:body,
          photos:val('[name="contact[photo_links]"]').split(/\n+/).filter(Boolean),
          src:(function(){try{return new URLSearchParams(location.search).get('src')||sessionStorage.getItem('dnd_src')||'';}catch(e){return '';}})()   /* v10.99 (#41): ?src=flyer on the tracked links the CRM hands out, or the stash from the landing page — 'Add more services' and every nav link drop the query, and the lead used to arrive as plain 'website' */
        }));
      }catch(e){}
    },true);
  }
  if(modal&&modal.classList.contains('show')){
    try{
      var saved=JSON.parse(sessionStorage.getItem('dnd_lead2')||'null'); sessionStorage.removeItem('dnd_lead2');
      /* v10.99 (#39): the lead really landed — this is the only place that knows it. */
      try{ sessionStorage.removeItem('dnd_basket'); sessionStorage.removeItem('dnd_formdraft'); }catch(e){}
      /* v10.83: the last gate, and the only one Shopify cannot route around. Everything upstream —
         the required attributes, our own checks — lives on a page that the spam challenge navigates
         away from; after the customer solves it Shopify re-sends the captured data from its own
         servers, where no script of ours runs. So before the phone rings or a card appears in the
         CRM, the lead has to actually be a lead. An incomplete one is dropped here: Shopify still
         has its own copy in the store inbox, so nothing is lost, but John is not woken for it. */
      if(saved){
        var need=[saved.name, saved.city, saved.service, saved.property, saved.timing, saved.body];
        var missing=need.filter(function(v){ return !String(v||'').trim(); }).length;
        if(missing || !(String(saved.phone||'').trim() || String(saved.email||'').trim())) saved=null;
      }
      var ops=window.DND_OPS;
      var hs=function(x){return String(x||'').replace(/[^\x20-\x7E]/g,' ').trim();};
      var pushed=false;   /* W06: exactly ONE push per lead, whichever path fires first (normal .then, catch, or pagehide) */
      var alertJohn=function(leadId){ if(pushed)return; pushed=true; // v10.53: instant owner alert with logo + tap-through into the Ops app
        var o=window.DND_OPS||{}, click=(o.ops||(location.origin+'/pages/ops'))+(leadId?'?lead='+encodeURIComponent(leadId):'');
        /* v10.60: still exactly ONE push per lead. A multi-service lead names every service
           rather than firing once per service — the title stays short, the body lists them all. */
        var svcList=hs(saved.service), nSvc=svcList?svcList.split(' + ').length:0;
        var headline=nSvc>2?(nSvc+'-SERVICE'):(svcList.toUpperCase()||'NEW');
        var body={topic:'dumpdone-leads-9x4kq7m2vt',title:'\ud83d\udea8 NEW '+headline+' LEAD \ud83d\udea8',
          message:hs(saved.name)+' - '+hs(saved.city).toUpperCase()+' - '+(hs(saved.phone)||'no phone')
            +(nSvc>1?'\n'+svcList:''),priority:4,click:click};   /* v10.80: the tap-through stays
             (click), the words "(tap to open)" go — they ate a line of the notification to say
             what tapping a notification already does. */
        if(o.icon)body.icon=(String(o.icon).indexOf('//')===0?'https:':'')+o.icon; // asset_url is protocol-relative; ntfy needs https
        fetch('https://ntfy.sh',{method:'POST',body:JSON.stringify(body),keepalive:true}).catch(function(){});   /* W06: survives unload */
      };
      /* W06: if the visitor leaves before Apps Script answers, the push still goes out (without the lead id).
         pagehide is the event iOS Safari actually fires; a keepalive fetch inside it is the sanctioned beacon
         pattern; `pushed` guarantees the later .then cannot send a second push, including after a bfcache restore. */
      if(saved&&(saved.email||saved.phone)){ window.addEventListener('pagehide',function(){alertJohn('');},{once:true}); }
      if(saved&&(saved.email||saved.phone)&&ops&&ops.api&&ops.key){
        fetch(ops.api,{method:'POST',keepalive:true,headers:{'Content-Type':'text/plain'},body:JSON.stringify({key:ops.key,action:'lead.create',
          data:{name:saved.name,email:saved.email,phone:saved.phone,service:saved.service,load_size:saved.load_size,city:saved.city,
                details:saved.details,photos:saved.photos,source:(saved.src||'website'),source_detail:location.pathname}})})
          .then(function(r){return r.json();}).then(function(j){var l=j&&j.result;alertJohn(l&&l.id?l.id:'');}).catch(function(){alertJohn('');});
      }else if(saved&&(saved.email||saved.phone)){alertJohn('');}
    }catch(e){}
  }
})();
